import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Label from '../../atoms/Label';
import PillCheckboxGroup from '../../atoms/PillCheckboxGroup';

export default function PillSeclection({
  actions,
  loading,
}: {
  actions: { name: string; code: string }[];
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const methods = useFormContext();

  const [actionValue] = useWatch({
    name: ['action', 'products', 'selectedProducts'],
    control: methods.control,
  });
  const errors = methods.formState.errors;

  if (loading)
    return (
      <div className="space-y-2">
        <Label text={t('components.disputeFeature.selectDisputeReason')} />
        {/* <CustomizationSkeleton size="sm" /> */}
      </div>
    );

  return (
    <PillCheckboxGroup
      label={t('components.disputeFeature.selectAnAction')}
      options={actions?.map((r) => ({
        label: r.name,
        value: r.code,
      }))}
      value={!!actionValue ? [actionValue] : []}
      onChange={(e) => {
        const element = e.at(-1) as string;
        methods.reset();
        methods.setValue('action', element);
      }}
      name="action"
      helperText={errors?.action?.message as string}
      status={!!errors?.action?.message ? 'error' : 'success'}
    />
  );
}
